import strings from './strings';

class Localization {
    constructor(stringsLibrary) {
        this.stringsLibrary = stringsLibrary;
        this.defaultLang = 'en';
        this.noTextErrorMsg = 'NO TEXT DEFINED';
        this.storageKey = 'poker-app.locale';
        this.langChangeEvent = 'app_language_change';
        this._currentLang = null;
    }

    get currentLanguage() {
        if(!this._currentLang) {
            const savedLocale = window.localStorage.getItem(this.storageKey);
            this._currentLang = savedLocale || this.getBrowserLocale() || this.defaultLang;
        }
        return this._currentLang;
    }

    set currentLanguage(lang) {
        if (typeof lang === 'string') {
            this._currentLang = lang;
            window.localStorage.setItem(this.storageKey, lang);
        }
        document.body.parentNode.setAttribute('lang', lang);

        const langChangeEvent = new CustomEvent(this.langChangeEvent, { detail: { lang }});
        document.body.dispatchEvent(langChangeEvent);
    }

    getText(identifier) {
        if (!identifier) {
            return;
        }
        const texts = this.stringsLibrary[identifier];
        if (texts) {
            return texts[this.currentLanguage] || texts[this.defaultLang] || this.noTextErrorMsg;
        }
        return this.noTextErrorMsg;
    }

    getBrowserLocale() {
        const browserLocale = navigator.language || navigator.userLanguage;
        if (browserLocale.length < 2) {
            return;
        }
        return browserLocale.substring(0,2);
    }
}

const localization = new Localization(strings);

export default localization;



// WEBPACK FOOTER //
// ./src/localization.js